import React from "react";
import { Routes, Route } from "react-router-dom";
import ListAgent from "../Components/Agent/listAgent";
// import AddTeamMember from "../Components/Team Members/addTeamMember";
// import EditTeamMember from "../Components/Team Members/EditTeamMember";
import ViewAgents from "../Components/Agent/viewAgent";

const AgentRoutes = () => {
  return (
    <Routes>
      <Route path="/agent" element={<ListAgent></ListAgent>}></Route>
      {/* <Route path="/agent/add" element={<AddTeamMember></AddTeamMember>}></Route>
      <Route
        path="/agent/edit/:id"
        element={<EditTeamMember></EditTeamMember>}
      ></Route> */}
      <Route path="/agent/view/:id" element={<ViewAgents />}></Route>
    </Routes>
  );
};

export default AgentRoutes;
